import ProfileHeader from "@/components/features/user-profile/profile-header";
import { type ProfileViewModel } from "@/lib/types";
import { getAttributePills } from "@/lib/utils";

import ExpandableReadMoreText from "./expandable-read-more-text";
import { Badge } from "./ui/badge";

interface UserProfileProps {
  profile: ProfileViewModel;
}

export default function UserProfile({ profile }: Readonly<UserProfileProps>) {
  const pills = getAttributePills(profile);

  return (
    <div className="flex flex-col gap-6">
      <ProfileHeader profile={profile} label={`About ${profile.FirstName}`} />

      {/* ProfileAbout */}
      {profile.About && (
        <ExpandableReadMoreText
          id="about"
          text={profile.About}
          numberOfLines={4}
          className="text-black"
        />
      )}

      {/* ProfileAttributes */}
      <ul
        className="m-0 flex list-none flex-wrap gap-2 p-0"
        aria-label="Profile attributes"
      >
        {pills.map(({ icon: Icon, label }) => (
          <li key={label}>
            <Badge className="flex items-center gap-1 rounded-full px-3 py-4 text-sm [&>svg]:size-3.5">
              <Icon className="text-primary" aria-hidden="true" />
              {label}
            </Badge>
          </li>
        ))}
      </ul>
    </div>
  );
}
